import {
  ACTION_GET_AUDIT_EVENTS,
  ACTION_GET_AUDIT_EVENTS_SUCCESS,
  ACTION_GET_AUDIT_EVENTS_FAILURE,
  ACTION_GET_MORE_AUDIT_EVENTS,
  ACTION_GET_MORE_AUDIT_EVENTS_SUCCESS,
  ACTION_GET_MORE_AUDIT_EVENTS_FAILURE,
  ACTION_EMPTY_AUDIT_EVENTS,
} from '../configs/ActionTypes';

const initialState = {
  events: [] as any[],
  isLoading: false,
  isLoadingMore: false,
  hasMore: true,
  cursor: null as { id: string } | null,
  error: null as any,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_AUDIT_EVENTS: {
      return { ...state, isLoading: true, error: null };
    }

    case ACTION_GET_AUDIT_EVENTS_SUCCESS: {
      const { data, cursor } = action.payload.payload;
      const resolvedCursor = cursor ?? null;
      return {
        ...state,
        isLoading: false,
        events: data || [],
        cursor: resolvedCursor,
        hasMore: resolvedCursor !== null,
      };
    }

    case ACTION_GET_AUDIT_EVENTS_FAILURE: {
      return { ...state, isLoading: false, error: action.payload };
    }

    case ACTION_GET_MORE_AUDIT_EVENTS: {
      return { ...state, isLoadingMore: true, error: null };
    }

    case ACTION_GET_MORE_AUDIT_EVENTS_SUCCESS: {
      const { data, cursor } = action.payload.payload;
      const resolvedCursor = cursor ?? null;
      return {
        ...state,
        isLoadingMore: false,
        events: [...state.events, ...(data || [])],
        cursor: resolvedCursor,
        hasMore: resolvedCursor !== null,
      };
    }

    case ACTION_GET_MORE_AUDIT_EVENTS_FAILURE: {
      return { ...state, isLoadingMore: false, error: action.payload };
    }

    case ACTION_EMPTY_AUDIT_EVENTS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
